import { Config } from '@forgerock/javascript-sdk';
import { CMCFRSDK, useFRConfig } from './FRConfigSetup';
import { JourneyTree } from '../constants/FREnums';

export const getFRTokens = async () => {
  try {
    Config.get();
  } catch {
    useFRConfig(JourneyTree.FR_JOURNEY_LOGIN);
  }
  const tokensNew = await CMCFRSDK.TokenManager.getTokens({ forceRenew: false, login: `embedded` });
  return tokensNew;
};
